import { productImages } from '../constants/productImages';

type Product = {
  product_id: string;
  product_photo?: string | null;
};

export function getProductImage(p: Product): string | undefined {
  return productImages[p.product_id] ?? p.product_photo ?? undefined;
}
